import { render, staticRenderFns } from "./importPlayer.vue?vue&type=template&id=2a1eb1ca&scoped=true&"
import script from "./importPlayer.vue?vue&type=script&lang=ts&"
export * from "./importPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./importPlayer.vue?vue&type=style&index=0&id=2a1eb1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1eb1ca",
  null
  
)

export default component.exports